var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-body" },
    [
      _c("page-banner", _vm._b({}, "page-banner", _vm.page.banner, false)),
      _c(
        "page-limiter",
        [
          _vm.crumbs && _vm.crumbs.length
            ? _c("breadcrumbs", { attrs: { crumbs: _vm.crumbs } })
            : _vm._e()
        ],
        1
      ),
      _c("link", {
        attrs: {
          rel: "stylesheet",
          href:
            "https://stackpath.bootstrapcdn.com/bootstrap/4.2.1/css/bootstrap.min.css"
        }
      }),
      _c("div", { staticClass: "ovs_bnr" }, [
        _vm._m(0),
        _c("h1", [
          _vm._v(_vm._s(_vm.page.top_banner.header_title)),
          _c("div", [_vm._v(_vm._s(_vm.page.top_banner.header_subtitle))])
        ]),
        _c("h2", [_vm._v(_vm._s(_vm.page.top_banner.body_title))]),
        _c(
          "div",
          { staticClass: "ovs_bnr_body" },
          [
            _vm._l(_vm.page.top_banner.items, function(item) {
              return _c("div", { staticClass: "ovs_bnr_item" }, [
                _c("img", {
                  staticClass: "ovs_bnr_item_img",
                  attrs: { src: _vm.page.src + item.icon, alt: item.text }
                }),
                _c("p", { staticClass: "ovs_baner_item_text" }, [
                  _vm._v(_vm._s(item.text))
                ])
              ])
            }),
            _c("div", {
              staticClass: "ovs_bnr_main_img",
              style: { backgroundImage: "url(" + _vm.banerBg() + ")" }
            })
          ],
          2
        ),
        _c("img", {
          staticClass: "ovs_bnr_main_img_m",
          attrs: { src: "/images/ovsyanoe/min_ret_m.jpg" }
        }),
        _c(
          "div",
          { staticClass: "ovs_bnr_txt" },
          [
            _c("page-limiter", [
              _c("div", { staticClass: "row pt-3" }, [
                _c(
                  "div",
                  { staticClass: "d-none d-md-flex col-md-3 klishe-container" },
                  [
                    _c("img", {
                      staticClass: "w-100 ",
                      attrs: {
                        src: "/images/ovsyanoe/Klishe_02.png",
                        srcset: "/images/ovsyanoe/Klishe_02.png" + " 2x"
                      }
                    })
                  ]
                ),
                _c("div", { staticClass: "col-9 col-md-8" }, [
                  _c("h4", [_vm._v(_vm._s(_vm.page.top_banner.footer_title))]),
                  _c("p", [_vm._v(_vm._s(_vm.page.top_banner.footer_text))])
                ]),
                _c("div", { staticClass: "col-3 col-md-1 mascot-container" }, [
                  _c("img", {
                    staticClass: "mascot",
                    attrs: {
                      src: "/images/ovsyanoe/KFM_mascot_main_RGB.png",
                      srcset: "/images/ovsyanoe/KFM_mascot_main_RGB.png" + " 2x"
                    }
                  })
                ])
              ])
            ])
          ],
          1
        )
      ]),
      _c(
        "page-limiter",
        { staticClass: "ovs_content" },
        [
          _c("div", { staticClass: "row mt-4 mb-5 d-none d-md-block" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("img", {
                staticClass: "w-100",
                attrs: { src: _vm.page.src + _vm.page.categories.main_image }
              })
            ])
          ]),
          _vm._l(_vm.page.categories.items, function(item, index) {
            return _c("div", { staticClass: "row categories" }, [
              _c("div", { staticClass: "col-sm-6 col-12 mt-4 mb-5" }, [
                _c("img", {
                  staticClass: "w-100",
                  attrs: { src: _vm.page.src + item.o_category_img }
                })
              ]),
              _c("div", { staticClass: "col-sm-6 col-12 mt-4 mb-5" }, [
                item.o_category_link &&
                item.o_category_title &&
                item.o_category_type == "horizontal"
                  ? _c("a", { attrs: { href: [item.o_category_link] } }, [
                      _c("h4", [_vm._v(_vm._s(item.o_category_title))])
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  {
                    class: ["o_products", item.o_category_type, "item-" + index]
                  },
                  [
                    _c(
                      "div",
                      { class: ["o_product-item", item.o_category_type] },
                      [
                        item.o_category_link &&
                        item.o_category_title &&
                        item.o_category_type == "vertical"
                          ? _c(
                              "a",
                              { attrs: { href: [item.o_category_link] } },
                              [
                                _c("h4", [
                                  _vm._v(_vm._s(item.o_category_title))
                                ])
                              ]
                            )
                          : _vm._e(),
                        _c("div", { staticClass: "o_product" }, [
                          _c("div", { staticClass: "product_img_container" }, [
                            _c("img", {
                              staticClass: "product_img",
                              attrs: {
                                src: _vm.page.src + item.o_category_product1_img
                              }
                            })
                          ]),
                          _c("p", { staticClass: "product_title" }, [
                            _vm._v(_vm._s(item.o_category_product1_title))
                          ])
                        ])
                      ]
                    ),
                    _c(
                      "div",
                      { class: ["o_product-item", item.o_category_type] },
                      [
                        item.o_category_secondlink &&
                        item.o_category_secondtitle &&
                        item.o_category_type == "vertical"
                          ? _c(
                              "a",
                              { attrs: { href: item.o_category_secondlink } },
                              [
                                _c("h4", [
                                  _vm._v(_vm._s(item.o_category_secondtitle))
                                ])
                              ]
                            )
                          : _vm._e(),
                        _c("div", { staticClass: "o_product" }, [
                          _c("div", { staticClass: "product_img_container" }, [
                            _c("img", {
                              staticClass: "product_img",
                              attrs: {
                                src: _vm.page.src + item.o_category_product2_img
                              }
                            })
                          ]),
                          _c("p", { staticClass: "product_title" }, [
                            _vm._v(_vm._s(item.o_category_product2_title))
                          ])
                        ])
                      ]
                    )
                  ]
                ),
                _c("p", [_vm._v(_vm._s(item.o_category_text))])
              ])
            ])
          })
        ],
        2
      ),
      _vm.page.h1
        ? _c(
            "section",
            { staticClass: "page-section content-section" },
            [
              _c("page-limiter", [
                _c("div", {
                  staticClass: "page-content",
                  domProps: { innerHTML: _vm._s(_vm.page.content) }
                })
              ])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-none d-lg-block" }, [
      _c("img", {
        staticClass: "left-overlay ovs-bnr-overlay",
        attrs: { src: "/images/ovsyanoe/Kolos-l.png" }
      }),
      _c("img", {
        staticClass: "right-overlay ovs-bnr-overlay",
        attrs: { src: "/images/ovsyanoe/Kolos-r.png" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fea002f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fea002f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pages/PageOvsyanoe.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-fea002f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pages/PageOvsyanoe.vue
// module chunks = 0